import router from './router'
import personnelEmbezzlementMessages from './localization'

export default {
  router,
  localization: personnelEmbezzlementMessages,
}
